module.exports = __webpack_public_path__ + "media/images/favicon/favicon-cc89760ea0b9abbe20964380ba4f6243.ico";